import { useEffect, useState } from 'react'
import { useRespondToSubmissionMutation } from '@/core/services/form'
import { FormSubmission, FormSubmissionStatus } from '@/core/models/form.model'

type UseRespondToEthicsSubmissionParams = {
  submission: FormSubmission
  onCompleted: () => void
}

export function useRespondToEthicsSubmission({ submission, onCompleted }: UseRespondToEthicsSubmissionParams) {
  const [ethicsResponse, setEthicsResponse] = useState(submission.ethicsResponse || '')
  const [hasSubmitError, setHasSubmitError] = useState(false)
  const [respondToSubmission, { isLoading }] = useRespondToSubmissionMutation()

  useEffect(() => {
    setEthicsResponse(submission.ethicsResponse || '')
    setHasSubmitError(false)
  }, [submission])

  const handleSubmit = async () => {
    setHasSubmitError(false)

    try {
      await respondToSubmission({
        id: submission._id,
        body: { ethicsResponse, status: FormSubmissionStatus.Resolved },
      }).unwrap()
      onCompleted()
    } catch {
      setHasSubmitError(true)
    }
  }

  return {
    ethicsResponse,
    hasSubmitError,
    isLoading,
    canSubmit: Boolean(ethicsResponse.trim()) && !isLoading,
    setEthicsResponse,
    handleSubmit,
  }
}
